import classNames from 'classnames'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useToggle } from 'react-use'

import { HStack } from '~/components/elements/HStack'
import { StyledButton } from '~/components/elements/StyledButton'
import { DataDisplayTypeAtomSwitcher } from '~/components/features/DataDisplayTypeAtomSwitcher'

import { dataDisplayTypeAtom } from '../../atoms'
import { DisplayItemSettingsDialog } from '../DisplayItemSettingsDialog'

import { SurveyGroupSelectorContainer } from './SurveyGroupSelectorContainer'
import { TableChartSwitcher } from './TableChartSwitcher'
import styles from './TimeSeriesAnalysisHeader.css'
import { UnifyMaxSwitch } from './UnifyMaxSwitch'

export type TimeSeriesAnalysisHeaderProps = {
  className?: string
}

export const TimeSeriesAnalysisHeader = ({
  className,
}: TimeSeriesAnalysisHeaderProps) => {
  const { t } = useTranslation()
  const [
    isVisibleDisplayItemSettingsDialog,
    toggleIsVisibleDisplayItemSettingsDialog,
  ] = useToggle(false)

  return (
    <HStack
      className={classNames(styles.root, className)}
      justify="space-between"
      padding={2}
      spacing={4}
    >
      <HStack spacing={2}>
        <SurveyGroupSelectorContainer />

        <TableChartSwitcher />

        <DataDisplayTypeAtomSwitcher
          dataDisplayTypeAtom={dataDisplayTypeAtom}
          withoutNumber={true}
        />
      </HStack>

      <HStack spacing={2}>
        <StyledButton
          buttonStyle="light"
          icon="gears"
          onClick={toggleIsVisibleDisplayItemSettingsDialog}
        >
          {t('select_data_1')}
        </StyledButton>

        <UnifyMaxSwitch />
      </HStack>

      {isVisibleDisplayItemSettingsDialog && (
        <DisplayItemSettingsDialog
          onClose={toggleIsVisibleDisplayItemSettingsDialog}
        />
      )}
    </HStack>
  )
}
